<template>
  <md-card class="md-card-global-sales">
    <md-card-header :class="getClass(headerColor)" class="md-card-header-icon">
      <slot name="header" />
    </md-card-header>

    <md-card-content>
      <slot name="content" />
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "GlobeActivitySlimCard",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + ""
    }
  }
}
</script>
